import React from "react";
import styled from "styled-components";

const ListContainer = styled.ul`
  /* width: 300px; */
  list-style-type: none;
  padding: 0px;
  max-height: 400px;
  overflow: auto;
`;

const ListItem = styled.li`
  padding: 10px 10px 10px 10px;
  &:hover {
    background-color: #d4eafa;
  }
`;

export default function ResultsList({ items, template , onClickCallback}) {

  // const onItemClicked = (value) =>{
  //   console.log("selected item");
  //   console.log(value)
  //   onClickCallback(value);
  // }

  const handleKeyPress = (e,item) => {
    if(e.key=='Enter'){
      onClickCallback(item);
    }
  }
  return (
    <ListContainer>
      {items.map((item, index) => (
        <ListItem key={index} onClick={() => onClickCallback(item)} onKeyPress={(e) => handleKeyPress(e,item)} tabIndex="0">
          {template(item)}
        </ListItem>
      ))}
    </ListContainer>
  );
}
